import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  AppBar,
  CssBaseline,
  useScrollTrigger
} from '@material-ui/core'
import { Logo, SearchField } from '../Atoms'
import { ButtonCollection } from '../Molecules'
import { FilterBar } from '../Organisms'
import { useBreakpoints } from '../../utils/Breakpoints'
import { goToHome } from '../../utils/UrlManipulation'

const useStyles = makeStyles(theme => ({
  header: {
    overflowX: 'auto',
    overflowY: 'hidden',
    backgroundColor: '#ffffff',
  },
  searchHeader: {
    height: 64,
    minWidth: 800,
    boxSizing: 'content-box',
    paddingLeft: "2rem",
    paddingRight: "2rem",
    borderBottom: '1px solid rgb(143, 180, 202, 0.5)',
    zIndex: theme.zIndex.drawer - 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
  },
  filterHeader: {
    height: 64,
    minWidth: 800,
    boxSizing: 'content-box',
    borderBottom: '1px solid rgb(143, 180, 202, 0.5)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
  },
  filterContainer: {
    marginLeft: '5vw',
  },
  leftContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  centerContainer: {
    flexGrow: 1,
    maxWidth: "50%",
    minWidth: 400,
    marginLeft: "1rem",
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '100%',
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}))

function ElevationScroll({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}

const MainPageContainer = ({ showFilters = false, children }) => {
  const classes = useStyles()

  const breakpoints = useBreakpoints()

  return (
    <React.Fragment>
      <CssBaseline />
      <ElevationScroll>
        <AppBar className={classes.header}>
          <div className={classes.searchHeader}>
            <div className={classes.leftContainer}>
              <Logo
                onClick={goToHome}
                collapsed={!breakpoints.md}
                style={{
                  height: 32,
                  cursor: "pointer",
                }}
              />
            </div>
            <div className={classes.centerContainer}>
              <SearchField />
            </div>
            <div>
              <ButtonCollection />
            </div>
          </div>
          {showFilters &&
            <div className={classes.filterHeader}>
              <div className={classes.filterContainer}>
                <FilterBar />
              </div>
            </div>
          }
        </AppBar>
      </ElevationScroll>
      <div
        className={classes.content}
        style={{ paddingTop: showFilters ? '10rem' : '6rem' }}
      >
        {children}
      </div>
    </React.Fragment>
  )
}

export default MainPageContainer
